<template>
  <div :id="'view-'+name" class="content-wrapper">
    <background-video-player
      :ref="videoPlayerId"
      :key="videoPlayerId"
      :videos="videoSource"
      :videoPlayerId="videoPlayerId"
    />
    <!-- <hoverable-svg :hoverableItems="hoverable" :hoverableId="hoverableId" :ref="hoverableId"/> -->
    <div class="msg-overlay"></div>
    <div class="pageTitle"></div>
    <hr class="titleSeparator">

    <div class="msg">
      <text-content key="msg3" v-if="init" :lines="msg1" :delay="textDelay"/>
      <text-content key="msg4" v-else :lines="msg2" :delay="textDelay"/>
    </div>

    <cf-button
      :width=280
      :key="'view-'+name+'-continue'"
      :id="'view-'+name+'-continue'"
      v-if="init"
      class="nav-btn btn-continue"
      @click.native="handleClick"
      :content="'Continue'"
    />
    <cf-button
      :width=280
      :key="'view-'+name+'-restart'"
      :id="'view-'+name+'-restart'"
      v-else
      class="nav-btn btn-continue"
      @click.native="handleClick"
      :content="'Restart'"
      animation
      :to="{name: 'Home'}"
    />
  </div>
</template>

<script>
import HoverableSvg from "@/components/Hoverable-SVG";
import CfButton from "@/components/CF-Button";
import BackgroundVideoPlayer from "@/components/Background-Video-Player";
import TextContent from "@/components/TextContent";
import BaseViewPage from "@/views/BaseViewPage";

export default {
  extends: BaseViewPage,
  components: {
    BackgroundVideoPlayer,
    CfButton,
    TextContent,
    HoverableSvg
    // HoverableImage
  },
  data() {
    return {
      init: true,
      message: [],
      msg1: [
        `Customer outcomes`,
        `•&nbsp;&nbsp;<strong>9.2%</strong> output increase`,
        `•&nbsp;&nbsp;<strong>2.9%</strong> efficiency improvement`,
        `•&nbsp;&nbsp;<strong>32,000</strong> hours maintenance interval extension`
      ],
      msg2: [
        `GE’s upgrades to the gas turbine, in combination with`,
        `upgrades to the steam turbine and generator helped`,
        `us exceed GPG’s expectations – allowing them to`,
        `generate more power while improving operating and`,
        `maintenance costs.`
      ],
      navBtnImg: {
        imageSrc: "static/images/home/Btn1.png"
      }
    };
  },
  computed: {
    delay() {
      // if from route is defined, i.e coming from a different page, then we need a bit delay for transition to happen
      // otherwise, if it is load directly, then there should not be delay.
      console.log(
        `Coming from route ${this.$router.from} tween delay ${
          this.$router.from ? 1 : 0
        }`
      );
      return this.$router.from ? 3 : 2;
    },
    textDelay() {
      let textDelay;
      if (this.init) {
        textDelay = this.delay + 1.8;
      } else {
        textDelay = 0;
      }
      return textDelay;
    }
  },
  methods: {
    handleClick() {
      // pop a message dialog
      this.init = false;
      this.message = this.msg2;
    },
    resetAnimation() {
      TweenMax.from(`#view-${this.name} .msg-overlay`, 2, {
        left: -800,
        ease: Expo.easeOut,
        delay: this.delay
      });
      TweenMax.to(`#view-${this.name} .pageTitle`, 0, {
        css: { className: "+=loadingTitle" },
        delay: this.delay + 1
      });
      TweenMax.from(`#view-${this.name} .titleSeparator`, 0.5, {
        ease: "Expo.easeOut",
        opacity: 0,
        delay: this.textDelay
      });

      TweenMax.fromTo(
        `#view-${this.name} .nav-btn`,
        1,
        { top: 960, opacity: 0 },
        {
          top: 910,
          ease: "Expo.easeOut",
          opacity: 1,
          delay: this.textDelay + 0.2
        }
      );
    },
    deactivated() {
      TweenMax.to(`#view-${this.name} .pageTitle`, 0, {
        css: { className: "-=loadingTitle" }
      });
    },
    activated() {
      this.$emit("require-back-link", this.backLink);
      this.init = true;
      this.message = this.msg1;
      this.$nextTick(() => {
        this.$refs[this.videoPlayerId].play();
        this.resetAnimation();
      });     
    }
  }
};
</script>
<style lang="css" rel="stylesheet/css" scoped>
.btn-continue {
  left: 68px;
}
.info-btn {
  float: right;
  position: relative;
  cursor: pointer;
  top: -20px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// result.vue?4a9f5f58